import * as Sentry from '@sentry/react';

import { getUser } from '@cast/infrastructure-auth';
import { isE2E } from '@cast/utils';

import {
  DEFAULT_COM_DBO_DEMO_FORM_ID,
  DEFAULT_COM_FORM_ID,
  DEFAULT_COM_SEC_RUNTIME_DEMO_FORM_ID,
  DEFAULT_COM_SUBMISSION_CONFIG_BASE,
} from 'core/integrations/schedule-meeting/_constants';

type OpenScheduleDialogArgs = {
  onMeetingBooked?: () => void;
  onError?: (error: unknown) => void;
};

const openScheduleDialogByFormId = (
  formId: number,
  callbacks: OpenScheduleDialogArgs = {}
): void => {
  if (isE2E()) {
    callbacks.onMeetingBooked?.();
    return;
  }

  const { email, name } = getUser() || { email: '', name: '' };
  const defaultComSDK = window.DefaultSDK;

  if (!defaultComSDK) {
    const error = new Error(
      'Default.com SDK is not available. The script may not be loaded, e.g. blocked by an ad blocker'
    );
    error.name = 'ScriptNotLoadedError';
    Sentry.captureMessage(error.message, {
      level: 'warning',
      extra: { formId },
    });
    callbacks.onError?.(error);
    return;
  }

  void defaultComSDK.submit(
    {
      ...DEFAULT_COM_SUBMISSION_CONFIG_BASE,
      form_id: formId,
      responses: {
        name,
        email,
      },
    },
    callbacks
  );
};

type OpenScheduleDialogFn = (callbacks?: OpenScheduleDialogArgs) => void;

export const openScheduleDialog: OpenScheduleDialogFn = (callbacks = {}) => {
  openScheduleDialogByFormId(DEFAULT_COM_FORM_ID, callbacks);
};

export const openScheduleRuntimeDialog: OpenScheduleDialogFn = (
  callbacks = {}
) => {
  openScheduleDialogByFormId(DEFAULT_COM_SEC_RUNTIME_DEMO_FORM_ID, callbacks);
};

export const openScheduleDBODemoDialog: OpenScheduleDialogFn = (
  callbacks = {}
) => {
  openScheduleDialogByFormId(DEFAULT_COM_DBO_DEMO_FORM_ID, callbacks);
};
